import ko from 'knockout';
import debounce from 'lodash.debounce';
import { closePopups, openPopup } from '../../init';
import { customFetch as fetch, CustomError } from '../../fetch';
import { errorToast, successToast } from '../../toastr-helper';

export class TfaModel {
    validationErrors: KnockoutObservableArray<CustomError>;
    tfaEnabled: KnockoutObservable<boolean>;
    sendingVerificationCode: KnockoutObservable<boolean>;
    confirmingVerificationCode: KnockoutObservable<boolean>;
    disablingTfa: KnockoutObservable<boolean>;
    lastSendVerificationCode: KnockoutObservable<number | null>;
    verificationCode: KnockoutObservable<string>;

    phoneNumber: KnockoutObservable<string>;

    constructor(model: any = {}) {
        this.validationErrors = ko.observableArray<CustomError>();
        this.tfaEnabled = ko.observable<boolean>(model.tfaEnabled);
        this.sendingVerificationCode = ko.observable<boolean>();
        this.confirmingVerificationCode = ko.observable<boolean>();
        this.disablingTfa = ko.observable<boolean>();
        this.lastSendVerificationCode = ko.observable<number | null>(null);
        this.phoneNumber = model.phoneNumber;

        this.verificationCode = ko.observable<string>()
            .extend({ errorHandler: { source: this.validationErrors, id: 'VerificationCode' } });
    }

    debouncedSendVerificationCode = debounce(async () => await this.sendVerificationCode(), 250);

    async sendVerificationCode() {
        if (this.tfaEnabled()) {
            return;
        }

        const timestamp = Date.now();

        const secondsSinceLastCode = Math.round(((timestamp - this.lastSendVerificationCode()!) / 1000))

        if (this.lastSendVerificationCode() && secondsSinceLastCode < 30) {
            errorToast(`U probeert te veel verificatiecodes te versturen. Wacht ${secondsSinceLastCode} seconden en probeer het nogmaals`);
            return;
        }

        this.sendingVerificationCode(true);

        const response = await fetch('/Tfa/SendVerificationCode', {
            method: 'POST'
        });

        this.sendingVerificationCode(false);
        this.lastSendVerificationCode(timestamp);

        if (response.ok) {
            successToast('De verificatiecode is succesvol verstuurd');
        } else if (response.errors) {
            if (response.errors.length > 0) {
                //Show custom exception to user
                errorToast(response.errors[0].message);
            } else {
                //General exception occurred
                errorToast('Er ging iets mis tijdens het verzenden van de verificatiecode. Probeer het later nog eens.');
            }
        }
    }

    async confirmVerificationCode() {
        const fd = new FormData();
        fd.append('verificationCode', this.verificationCode() || '');

        this.confirmingVerificationCode(true);

        const response = await fetch('/Tfa/ConfirmVerificationCode', {
            method: 'POST',
            body: fd
        });

        this.confirmingVerificationCode(false);

        if (response.ok) {
            successToast('2-factorauthenticatie is succesvol ingeschakeld.');
            this.closePopup();
            this.tfaEnabled(true);
            this.validationErrors([]);
        } else {
            if (response.errors) {
                this.validationErrors(response.errors);

                const generalError = response.errors.find(e => e.key === 'general');
                if (generalError) {
                    errorToast(generalError.message);
                }
            }
        }
    }

    async disableTfa() {
        this.disablingTfa(true);

        const response = await fetch('/Tfa/DisableTfa', {
            method: 'POST'
        });

        this.disablingTfa(false);

        if (response.ok) {
            successToast('2-factorauthenticatie is succesvol uitgeschakeld.');
            this.closePopup();
            this.tfaEnabled(false);
        }
    }

    closePopup() {
        closePopups();
    }
}
